// extracted by mini-css-extract-plugin
module.exports = {"colorPickerPopover":"style_colorPickerPopover__2VIvc","colorPicker":"style_colorPicker__-52o_"};